import { Design, WorkflowPrompt } from '../../../types';

export function getWfsFillerPrompts({
  fillerPrompts,
  languages
}: Design): WorkflowPrompt[] {
  return Object.values(fillerPrompts).flatMap((prompts) => {
    return prompts.filter(({ externalAudioPrompt }) => {
      return !externalAudioPrompt;
    }).map((prompt): WorkflowPrompt => {
      return {
        inputs: [],
        name: prompt.name,
        text: Object.fromEntries(languages.map(({ language }) => {
          const { transcript } = prompt.transcripts.find(({ locale }) => {
            return locale === language;
          }) ?? {};
          return [language, transcript?.trim() ?? ''];
        }).filter(([_, languageText]) => {
          return !!languageText;
        })),
        readyForActivation: true
      };
    });
  });
}
